import React, { useState, useRef, useMemo } from "react";
// import {
//   dobInput,
//   genderAtom,
//   prefilldatedataa,
// } from "../../component/event/app/atom/showbookingatom";
import { useAtom } from "jotai";
// import { useEffect } from "react";
// import DatePicker from "react-datepicker";
import { Icon } from "semantic-ui-react";
// import dayjs from "dayjs";
import moment from "moment";
import { startOfWeek, endOfWeek, format } from "date-fns";

const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

// this will help us generate random string for room name
export function generateString(length) {
  let result = " ";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result.trim();
}

// export function DateComponent({ disabled }) {
//   // const [prefiledDates, setPrefiledDates] = useAtom(prefilldatedataa);
//   const [disable, setDisable] = useState(false);

//   // const [date, setDate] = useState(["", "", ""]);

//   const inputRefs = [useRef(), useRef(), useRef()];
//   const [DateOfBirth, setDateOfBirth] = useAtom(dobInput);
//   //("ye dhek comparision", DateOfBirth.isError);
//   const handleInputChange = (index, value) => {
//     if (index < 2) {
//       if (value.length <= 2 && !isNaN(value) && value !== "00") {
//         const newDate = [...prefiledDates];
//         newDate[index] = value;
//         setPrefiledDates(newDate);
//         if (value.length === 2 && index < 2) {
//           inputRefs[index + 1].current.focus();
//         }
//       }
//     } else if (index === 2) {
//       if (value.length <= 4 && !isNaN(value) && value !== "0000") {
//         const newDate = [...prefiledDates];
//         newDate[index] = value;
//         setPrefiledDates(newDate);
//       }
//     }
//   };
//   useMemo(() => {
//     const day = parseInt(prefiledDates?.[0]);
//     const month = parseInt(prefiledDates?.[1]);
//     const year = parseInt(prefiledDates?.[2]);
//     const daysInMonth = new Date(year, month, 0).getDate();

//     if (
//       day >= 1 &&
//       day <= daysInMonth &&
//       month >= 1 &&
//       month <= 12 &&
//       year >= 1923 &&
//       year <= new Date().getFullYear()
//     ) {
//       setDateOfBirth({ ...DateOfBirth, isError: false });
//     } else {
//       setDateOfBirth({ ...DateOfBirth, isError: true });
//     }
//   }, [prefiledDates, setDateOfBirth]);

//   useMemo(() => {
//     if (prefiledDates === undefined) {
//       setPrefiledDates(["", "", ""]);
//       setDisable(false);
//     } else {
//       setDisable(true);
//     }
//   }, [disabled, prefiledDates]);

//   return (
//     <div style={{ display: "flex", gap: "5px", textAlign: "center" }}>
//       {prefiledDates?.map((value, index) => {
//         return (
//           <input
//             style={{
//               width: index == 2 ? "55px" : "40px",
//               outline: "none",
//               padding: "4px",
//               border:
//                 (prefiledDates?.[0] ||
//                   prefiledDates?.[1] ||
//                   prefiledDates?.[2]) &&
//                 DateOfBirth.isError
//                   ? "1px solid red"
//                   : "",
//             }}
//             className={
//               (prefiledDates?.[0] ||
//                 prefiledDates?.[1] ||
//                 prefiledDates?.[2]) &&
//               DateOfBirth.isError
//                 ? "field error"
//                 : ""
//             }
//             key={index}
//             ref={inputRefs[index]}
//             placeholder={index === 0 ? "DD" : index === 1 ? "MM" : "YYYY"}
//             type="number"
//             value={value}
//             disabled={disabled}
//             onChange={(e) => {
//               handleInputChange(index, e.target.value);
//             }}
//             maxLength={index === 2 ? 4 : 2} // Set maxLength to 4 for the year input
//             title={
//               (index === 0 && prefiledDates?.[0] < 1) ||
//               prefiledDates?.[0] > 31 ||
//               (index === 1 && prefiledDates?.[1] < 1) ||
//               prefiledDates?.[1] > 12 ||
//               (index === 2 && prefiledDates?.[2] > 1923) ||
//               prefiledDates?.[2] < 2023
//                 ? "Invalid date. Please enter a valid date."
//                 : ""
//             }
//           />
//         );
//       })}
//     </div>
//   );
// }

// export const DateCalendar = () => {
//   const [selectedDate, setSelectedDate] = useState(null);
//   const today = new Date();

//   const handleDateChange = (date) => {
//     if (date > today) {
//       setSelectedDate(date);
//     }
//   };

//   return (
//     <div>
//       <div>
//         <Icon
//           name="calendar" // Replace with the Semantic UI icon name you want
//           onClick={() => {
//             setSelectedDate(null); // Reset selected date
//           }}
//         />

//         {selectedDate && (
//           <DatePicker
//             selected={selectedDate}
//             onChange={handleDateChange}
//             minDate={today}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export const calculateAge = (dateArray) => {
//   if (typeof dateArray === "string") {
//     const birthdateObject = dayjs(dateArray);
//     const currentDate = dayjs();

//     // Calculate the difference in months and years
//     const months = currentDate.diff(birthdateObject, "month");
//     const years = Math.floor(months / 12);
//     const remainingMonths = months % 12;

//     // If age is less than 6 months, round off to the nearest month
//     if (months < 6) {
//       return months === 1 ? "1 month" : `${months} months`;
//     }
//     if (remainingMonths < 6) {
//       return years;
//     } else {
//       return years + 1;
//     }
//   } else {
//     const birthDate = new Date(
//       dateArray?.[2],
//       dateArray?.[1] - 1,
//       dateArray?.[0]
//     );
//     const currentDate = new Date();
//     const ageInMilliseconds = currentDate - birthDate;
//     const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25); // taking leap years into account

//     // Round the age to the nearest whole number
//     const roundedAge = Math.floor(ageInYears);

//     return roundedAge;
//   }
// };

export const truncateString = (str, length) => {
  if (str.length > length) {
    return str.substring(0, length) + "...";
  } else {
    return str;
  }
};

export function convertToIST(timestamp) {
  // Create a Date object
  var date = new Date(timestamp);

  // Convert to IST (Indian Standard Time)
  var options = { timeZone: "Asia/Kolkata" };
  var istDateTime = date.toLocaleString("en-US", options);

  return istDateTime;
}

export const calculateAgeString = (birthdateString) => {
  const birthdate = new Date(birthdateString);
  const currentDate = new Date();

  const differenceInMilliseconds = currentDate - birthdate;
  const age = Math.floor(
    differenceInMilliseconds / (365.25 * 24 * 60 * 60 * 1000)
  );

  return age;
};
export function DifferenceCalculator(date1, date2) {
  const differenceInMilliseconds = Math.abs(date2 - date1);

  const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

  return differenceInMinutes >= 15;
}

// export const RadioComponent = ({ error, disabled }) => {
//   //("radio component", error);
//   const [selectedOption, setSelectedOption] = useAtom(genderAtom);
//   //("selectedOption", selectedOption);
//   const handleOptionChange = (event) => {
//     //  imp
//     // if(event.target.value=="male"){
//     //   setSelectedOption(null);
//     // }else{
//     //   setSelectedOption(event.target.value);
//     // }
//     // imp end
//     setSelectedOption(event.target.value);
//   };

//   const radioStyle = {
//     display: "flex",
//     alignItems: "center",
//     color: "black",
//     marginBottom: "10px",
//   };

//   return (
//     <div style={{ display: "flex", gap: "10px" }}>
//       <div style={radioStyle}>
//         <input
//           type="radio"
//           value="Male"
//           checked={selectedOption === "Male"}
//           onChange={handleOptionChange}
//           disabled={disabled && selectedOption !== null}
//         />
//         <label style={{ marginLeft: "5px", marginTop: "2px" }}>Male</label>
//       </div>
//       <div style={radioStyle}>
//         <input
//           type="radio"
//           value="Female"
//           checked={selectedOption === "Female"}
//           onChange={handleOptionChange}
//           disabled={disabled && selectedOption !== null}
//         />
//         <label style={{ marginLeft: "5px", marginTop: "2px" }}>Female</label>
//       </div>
//       <div style={radioStyle}>
//         <input
//           type="radio"
//           value="Other"
//           checked={selectedOption === "Other"}
//           onChange={handleOptionChange}
//           disabled={disabled && selectedOption !== null}
//         />
//         <label style={{ marginLeft: "5px", marginTop: "2px" }}>Other</label>
//       </div>
//     </div>
//   );
// };

export function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
// Usage:

// // import React, { useState, useRef } from "react";
// import { dobInput } from "../../component/event/app/atom/showbookingatom";
// import { useAtom } from "jotai";
// const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

// // this will help us generate random string for room name

// export function generateString(length) {
//   let result = " ";
//   const charactersLength = characters.length;
//   for (let i = 0; i < length; i++) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//   }

//   return result.trim();
// }

// export  function DateComponent() {
//   const [date, setDate] = useState(["", "", ""]);
//   const inputRefs = [useRef(), useRef(), useRef()];
//   const [DOB,setDOB]=useAtom(dobInput)
//   const handleInputChange = (index, value) => {
//     if (index < 2) {
//       if (value.length <= 2 && !isNaN(value) && parseInt(value) <= 12) {
//         const newDate = [...date];
//         newDate[index] = value;
//         setDate(newDate);
//         if (value.length === 2 && index < 2) {
//           inputRefs[index + 1].current.focus();
//         }
//       }
//     } else if (index === 2) {
//       // Handle the year input with a maximum length of 4 and a valid range
//       if (value.length === 4 && !isNaN(value) && parseInt(value) >= 1900 && parseInt(value) <= new Date().getFullYear()) {
//         const newDate = [...date];
//         newDate[index] = value;
//         setDate(newDate);
//         setDOB(newDate);
//       }
//     }
//     if (isValidDate(new Date(date[2], date[1] - 1, date[0]))) {
//       // The date is valid, you can proceed with it.
//     } else {
//       // The date is not valid, you can provide feedback to the user.
//     }
//   };

//   function isValidDate(dateObj) {
//     // Check if the date is valid, considering leap years and month lengths
//     if (dateObj instanceof Date && !isNaN(dateObj)) {
//       const year = dateObj.getFullYear();
//       const month = dateObj.getMonth();
//       const day = dateObj.getDate();
//       const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
//       const daysInMonth = [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

//       return day >= 1 && day <= daysInMonth[month];
//     }
//     return false;
//   }

//   return (

//       <div style={{ display: "flex", gap: "5px", textAlign: "center" }}>
//         {date.map((value, index) => {
//           return (
//             <input
//               style={{
//                 width: index == 2 ? "55px" : "40px",
//                 outline: "none",
//                 padding: "4px"
//               }}
//               key={index}
//               ref={inputRefs[index]}
//               placeholder={index === 0 ? "DD" : index === 1 ? "MM" : "YYYY"}
//               type="text"
//               value={value}
//               onChange={(e) => handleInputChange(index, e.target.value)}
//               maxLength={index === 2 ? 4 : 2} // Set maxLength to 4 for the year input
//             />
//           );
//         })}
//       </div>

//   );
// }

export function formatDate(inputDateString) {
  const inputDate = inputDateString ? new Date(inputDateString) : new Date();
  const options = { year: "numeric", month: "long", day: "numeric" };
  return inputDate.toLocaleDateString("en-US", options);
}

export const extractTimeFromTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const formattedTime = `${hours}:${minutes}:${seconds}`;
  return formattedTime;
};

export function capitalizeFirstWord(input) {
  return input.replace(/(^\w{1})|(\s+\w{1})/g, (match) => match.toUpperCase());
}

export const deepCopy = (obj, visited = new WeakMap()) => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (visited.has(obj)) {
    return visited.get(obj);
  }

  const newObj = Array.isArray(obj) ? [] : {};
  visited.set(obj, newObj);

  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepCopy(obj[key], visited);
    }
  }
  return newObj;
};

export const GetInSeconds = (time) => {
  let time1 = time.split(":");
  // converting IST to utc seconds
  return Number(time1[0]) * 3600 + Number(time1[1]) * 60 - 19800;
};

// export const formatSecondsToHHMM = (seconds) => {
//   if (seconds === "") {
//     return "";
//   }
//   const hours = Math.floor(seconds / 3600);
//   const minutes = Math.floor((seconds % 3600) / 60);

//   const formattedHours = String(hours).padStart(2, "0");
//   const formattedMinutes = String(minutes).padStart(2, "0");

//   return `${formattedHours}:${formattedMinutes}`;
// };

// export const GetInSeconds = (time) => {

//   let time1 = time.split(":");
//   let hours = Number(time1[0]);
//   let minutes = Number(time1[1].split(" ")[0]);
//   let period = time1[1].split(" ")[1];

//   if (period === "PM" && hours !== 12) {
//     hours += 12;
//   }
//   if (period === "AM" && hours === 12) {
//     hours = 0;
//   }

//   return hours * 3600 + minutes * 60;
// };

// export const formatSecondsToHHMM = (seconds) => {
//   if (seconds === "") {
//     return "";
//   }
//   const hours = Math.floor(seconds / 3600);
//   const minutes = Math.floor((seconds % 3600) / 60);

//   const formattedHours = String(hours).padStart(2, "0");
//   const formattedMinutes = String(minutes).padStart(2, "0");

//   return `${formattedHours}:${formattedMinutes}`;
// };

export const formatSecondsToHHMM = (seconds) => {
  if (seconds === "") {
    return "";
  }

  const hours = Math.floor((seconds + 19800) / 3600);
  const minutes = Math.floor(((seconds + 19800) % 3600) / 60);

  // Format hours and minutes with leading zeros
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};

export const getStartAndEndTime = (
  date,
  startTime,
  endTime,
  end_date = null
) => {
  const [startHours, startMinutes] = startTime?.split(":").map(Number);
  let endHours, endMinutes;
  if (endTime) {
    [endHours, endMinutes] = endTime?.split(":").map(Number);
  } else {
    const endDate = new Date(date);
    endDate.setHours(startHours);
    endDate.setMinutes(startMinutes + 5);
    endDate.setSeconds(0);
    endDate.setMilliseconds(0);
    endHours = endDate.getHours();
    endMinutes = endDate.getMinutes();
  }

  const startDate = new Date(date);
  startDate.setHours(startHours);
  startDate.setMinutes(startMinutes);
  startDate.setSeconds(0);
  startDate.setMilliseconds(0);

  const endDate = new Date(end_date ? end_date : date);
  endDate.setHours(endHours);
  endDate.setMinutes(endMinutes);
  endDate.setSeconds(0);
  endDate.setMilliseconds(0);

  const start_time = startDate.toISOString();
  const end_time = endDate.toISOString();

  return { start_time, end_time };
};

export const getDateInputFormat = (currentDate) => {
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(currentDate.getDate()).padStart(2, "0");
  const dateString = `${year}-${month}-${day}`;
  return dateString;
};

export const getFilteredSlotCount = (slots) => {
  const Total_Appointments = slots.length || 0;
  let Remaining = 0;
  let Completed = 0;
  let No_Show = 0;
  for (let i of slots) {
    if (i?.title === "booked") {
      Remaining += 1;
    }
    if (i?.title === "complete") {
      Completed += 1;
    }
    if (i?.title === "no show") {
      No_Show += 1;
    }
  }

  return {
    Total_Appointments,
    Remaining,
    Completed,
    No_Show,
  };
};

export const getQueryTime = (selectedSession, date) => {
  const startHours = selectedSession?.startTime?.getHours();
  const startMin = selectedSession?.startTime?.getMinutes();
  const currentDate = date;
  currentDate.setHours(startHours);
  currentDate.setMinutes(startMin);
  currentDate.setSeconds(0);
  const startTime = currentDate?.toISOString();
  const endHours = selectedSession?.endTime?.getHours();
  const endMin = selectedSession?.endTime?.getMinutes();
  const cDate = date;
  cDate.setHours(endHours);
  cDate.setMinutes(endMin);
  const endTime = currentDate?.toISOString();
  return { startTime, endTime };
};

export const getTimeInSeconds = (date) => {
  const parsedDate = moment(date);
  const seconds =
    parsedDate.hours() * 3600 +
    parsedDate.minutes() * 60 +
    parsedDate.seconds();
  return seconds;
};

export const getFilteredOpenSlots = (walkinSlots, openSlots) => {
  const filteredOpenSlots = walkinSlots?.filter((openSlot) => {
    const openStartTime = new Date(openSlot?.start)?.getTime();
    const openEndTime = new Date(openSlot?.end)?.getTime();

    // Check if any walk-in slot exists within the time range of the current open slot
    const isWalkinWithinRange = openSlots?.some((walkinSlot) => {
      const walkinStartTime = new Date(walkinSlot?.start)?.getTime();
      return walkinStartTime >= openStartTime && walkinStartTime < openEndTime;
    });

    // If no walk-in slot exists within the time range of the open slot, keep it
    return !isWalkinWithinRange;
  });
  return filteredOpenSlots;
};

export const checkExistingSlot = (bStartTime, bEndTime, slots) => {
  // Find the slot matching the 15-minute interval
  const bookingStartTime = new Date(bStartTime);
  const bookingEndTime = new Date(bEndTime);
  const slotToUpdate = slots?.find((slot) => {
    const slotStartTime = new Date(slot?.start);
    const slotEndTime = new Date(slot?.end);

    // Add 5 minutes to the slot's start time
    // const adjustedStartTime = new Date(slotStartTime);
    // adjustedStartTime.setMinutes(adjustedStartTime.getMinutes() + 5);

    // Check if the booking falls within the adjusted slot's interval
    return (
      slot?.title === "booked" &&
      bookingStartTime >= slotStartTime &&
      bookingEndTime <= slotEndTime
    );
  });
  return slotToUpdate;
};

export const calculateWeekRange = (date) => {
  const startOfTheWeek = startOfWeek(date); // Get the start of the week
  const endOfTheWeek = endOfWeek(date); // Get the end of the week
  return [startOfTheWeek, endOfTheWeek]; // Return an array containing the start and end times
};

export const isValidUrl = (url) => {
  const regex = /^(ftp|http|https):\/\/[^ "]+$/;
  return regex.test(url);
};

export function getTotalAppointmentsInMonth(data) {
  const monthData = {};

  data.forEach((event) => {
    const dayOfMonth = event?.start?.getDate();

    if (!monthData[dayOfMonth]) {
      monthData[dayOfMonth] = {
        total_walk_in: 0,
        total_virtual: 0,
        end: event.end,
      };
    }

    if (event?.is_walk_in || event?.is_online) {
      monthData[dayOfMonth].total_walk_in++;
    } else if (event?.is_walk_in === false) {
      monthData[dayOfMonth].total_virtual++;
    }
  });

  const monthArray = Object.keys(monthData).map((dayOfMonth) => ({
    title: `${monthData[dayOfMonth].total_walk_in} Walk in `,

    start: new Date(
      data[0].start?.getFullYear(),
      data[0].start?.getMonth(),
      parseInt(dayOfMonth)
    ),
    end: monthData[dayOfMonth].end,
    total_walk_in: monthData[dayOfMonth].total_walk_in,
    total_virtual: monthData[dayOfMonth].total_virtual,
    allDay: true,
  }));

  return [{ month: monthArray }];
}
